export default __webpack_public_path__ + "static/media/institution.82a2eeb5.svg";